module.exports = __webpack_public_path__ + "img/deliver-img-1-3.e499aa79.png";